import { Activity, AssetDetailsActivity, AssetIdentifierStatus, AssetSourceTypeConsolidated, AssetTransitDirection, Point } from "../swagger/caasService-v1";
export const GHOST_ASSET_ID = "08166b99-deea-4116-9f53-d734ee2aeb9e";
export const GHOST_ASSET_ENTRIES = [
    {
        activity: AssetDetailsActivity.CHARGING,
        assetId: "08166b99-deea-4116-9f53-d734ee2aeb9e",
        assetIdentifierStatus: AssetIdentifierStatus.UNKNOWN,
        assetName: "Unknown Machine #101",
        assetSerialNumber: "Unknown machine",
        assetSourceId: "GHOST-08166b99",
        assetSourceType: AssetSourceTypeConsolidated.GHOST,
        capacity: 0,
        location: {
            lastReportedTime: new Date().toISOString().replace("Z", ""),
            position: { coordinates: [51.817833, 5.3473053], type: Point.type.POINT },
            streetAddress: "Gemeneweg 4, 4063 CT Heesselt, Netherlands"
        },
        soc: 98,
        timestamp: new Date().toISOString().replace("Z", "")
    },
    {
        activity: AssetDetailsActivity.CHARGING,
        assetId: "08266b99-deea-4116-9f53-d734ee2aeb9e",
        assetIdentifierStatus: AssetIdentifierStatus.UNKNOWN,
        assetName: "Unknown Machine #102",
        assetSerialNumber: "Unknown machine",
        assetSourceId: "GHOST-08266b99",
        assetSourceType: AssetSourceTypeConsolidated.GHOST,
        capacity: 0,
        soc: 28,
        timestamp: "2026-05-11T22:30:00.000"
    },
    {
        activity: AssetDetailsActivity.CHARGING,
        assetId: "08366b99-deea-4116-9f53-d734ee2aeb9e",
        assetIdentifierStatus: AssetIdentifierStatus.UNKNOWN,
        assetName: "Unknown Machine #103",
        assetSerialNumber: "Unknown machine",
        assetSourceId: "GHOST-08366b99",
        assetSourceType: AssetSourceTypeConsolidated.GHOST,
        assetTransitDirection: AssetTransitDirection.AT_SITE,
        capacity: 0,
        chargingSource: "2df4eec8-0b7d-464c-9fef-715a29dcbf68",
        location: {
            lastReportedTime: "2026-05-13T23:02:00.000",
            position: { coordinates: [-87.82324, 42.88285], type: Point.type.POINT },
            streetAddress: "Tweede Nassaustraat 23, 1052 BK Amsterdam, Netherlands"
        },
        soc: 81,
        timestamp: "2026-05-13T23:02:00.000"
    },
    {
        activity: AssetDetailsActivity.CHARGING,
        assetId: "08104b99-deea-4116-9f53-d734ee2aeb9e",
        assetIdentifierStatus: AssetIdentifierStatus.UNKNOWN,
        assetName: "Unknown Machine #104",
        assetSerialNumber: "Unknown machine",
        assetSourceId: "GHOST-08166b99",
        assetSourceType: AssetSourceTypeConsolidated.GHOST,
        capacity: 0,
        location: {
            lastReportedTime: new Date().toISOString().replace("Z", ""),
            position: { coordinates: [51.817833, 5.3473053], type: Point.type.POINT },
            streetAddress: "Gemeneweg 4, 4063 CT Heesselt, Netherlands"
        },
        soc: 98,
        timestamp: new Date().toISOString().replace("Z", "")
    },
    {
        activity: AssetDetailsActivity.CHARGING,
        assetId: "08105b99-deea-4116-9f53-d734ee2aeb9e",
        assetIdentifierStatus: AssetIdentifierStatus.UNKNOWN,
        assetName: "Unknown Machine #105",
        assetSerialNumber: "Unknown machine",
        assetSourceId: "GHOST-08266b99",
        assetSourceType: AssetSourceTypeConsolidated.GHOST,
        capacity: 0,
        soc: 28,
        timestamp: "2026-05-11T22:30:00.000"
    },
    {
        activity: AssetDetailsActivity.CHARGING,
        assetId: "08106b99-deea-4116-9f53-d734ee2aeb9e",
        assetIdentifierStatus: AssetIdentifierStatus.UNKNOWN,
        assetName: "Unknown Machine #106",
        assetSerialNumber: "Unknown machine",
        assetSourceId: "GHOST-08366b99",
        assetSourceType: AssetSourceTypeConsolidated.GHOST,
        assetTransitDirection: AssetTransitDirection.AT_SITE,
        capacity: 0,
        chargingSource: "2df4eec8-0b7d-464c-9fef-715a29dcbf68",
        location: {
            lastReportedTime: "2026-05-13T23:02:00.000",
            position: { coordinates: [-87.82324, 42.88285], type: Point.type.POINT },
            streetAddress: "Tweede Nassaustraat 23, 1052 BK Amsterdam, Netherlands"
        },
        soc: 81,
        timestamp: "2026-05-13T23:02:00.000"
    },
    {
        activity: AssetDetailsActivity.CHARGING,
        assetId: "08107b99-deea-4116-9f53-d734ee2aeb9e",
        assetIdentifierStatus: AssetIdentifierStatus.UNKNOWN,
        assetName: "Unknown Machine #107",
        assetSerialNumber: "Unknown machine",
        assetSourceId: "GHOST-08166b99",
        assetSourceType: AssetSourceTypeConsolidated.GHOST,
        capacity: 0,
        location: {
            lastReportedTime: new Date().toISOString().replace("Z", ""),
            position: { coordinates: [51.817833, 5.3473053], type: Point.type.POINT },
            streetAddress: "Gemeneweg 4, 4063 CT Heesselt, Netherlands"
        },
        soc: 98,
        timestamp: new Date().toISOString().replace("Z", "")
    },
    {
        activity: AssetDetailsActivity.CHARGING,
        assetId: "08108b99-deea-4116-9f53-d734ee2aeb9e",
        assetIdentifierStatus: AssetIdentifierStatus.UNKNOWN,
        assetName: "Unknown Machine #108",
        assetSerialNumber: "Unknown machine",
        assetSourceId: "GHOST-08266b99",
        assetSourceType: AssetSourceTypeConsolidated.GHOST,
        capacity: 0,
        soc: 28,
        timestamp: "2026-05-11T22:30:00.000"
    },
    {
        activity: AssetDetailsActivity.CHARGING,
        assetId: "08109b99-deea-4116-9f53-d734ee2aeb9e",
        assetIdentifierStatus: AssetIdentifierStatus.UNKNOWN,
        assetName: "Unknown Machine #109",
        assetSerialNumber: "Unknown machine",
        assetSourceId: "GHOST-08366b99",
        assetSourceType: AssetSourceTypeConsolidated.GHOST,
        assetTransitDirection: AssetTransitDirection.AT_SITE,
        capacity: 0,
        chargingSource: "2df4eec8-0b7d-464c-9fef-715a29dcbf68",
        location: {
            lastReportedTime: "2026-05-13T23:02:00.000",
            position: { coordinates: [-87.82324, 42.88285], type: Point.type.POINT },
            streetAddress: "Tweede Nassaustraat 23, 1052 BK Amsterdam, Netherlands"
        },
        soc: 81,
        timestamp: "2026-05-13T23:02:00.000"
    }
];
export const GHOST_NETWORK_ENTRIES = [
    {
        activity: Activity.CHARGING,
        assetId: "08166b99-deea-4116-9f53-d734ee2aeb9e",
        assetName: "Unknown Machine #1",
        assetSerialNumber: "Unknown machine",
        assetSourceId: "GHOST-08166b99",
        assetSourceType: AssetSourceTypeConsolidated.GHOST,
        assetTransitDirection: AssetTransitDirection.AT_SITE,
        chargingSource: "2df4eec8-0b7d-464c-9fef-715a29dcbf68",
        location: {
            lastReportedTime: "2026-05-13T23:02:00.000",
            position: { coordinates: [-87.82324, 42.88285], type: Point.type.POINT },
            streetAddress: "Tweede Nassaustraat 23, 1052 BK Amsterdam, Netherlands"
        },
        soc: 100,
        timestamp: "2026-05-13T23:02:00.000"
    }
];
